export default __webpack_public_path__ + "static/media/upsell-dialog-img.b8e8fae8.png";